import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { ChakraProvider } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from './App';

import { SignInProvider } from './context/SignIn';

import theme from './config/theme';
import PacificoFont from './config/PacificoFont';
import SourceSansFont from './config/SourceSansFont';

axios.defaults.headers.common['jarvis-version'] = '2.0.0';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      {/* Fonts. */}
      <PacificoFont />
      <SourceSansFont />

      {/* Google OAuth Provider */}
      <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID!}>
        {/* Login. */}
        <SignInProvider>
          <App />
        </SignInProvider>
      </GoogleOAuthProvider>
    </ChakraProvider>
  </StrictMode>,
);
